module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('deposit_failed')))]), _vm._v(" "), (_vm.reason) ? _c('p', {
    staticClass: "has-text-danger"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('reason')))]), _vm._v("\n      " + _vm._s(_vm.reason) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('p', [(_vm.attempts < _vm.maxAttempts) ? [_vm._v("\n        " + _vm._s(_vm.$t('attempts', {
    attempts: _vm.attempts,
    maxAttempts: _vm.maxAttempts
  })) + "\n        "), (_vm.attempts == 1) ? [_vm._v(_vm._s(_vm.$t('two_more_remaining')))] : (_vm.attempts == 2) ? [_vm._v(_vm._s(_vm.$t('one_more_remaining')))] : _vm._e()] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('please_contact_bank'))
    }
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60fc6816"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finance/deposit-return/EDataFailed.vue
// module id = 772
// module chunks = 0